var map = {
	"./Background/0.png": 3883,
	"./Background/1.png": 1153,
	"./Background/2.png": 4724,
	"./Background/3.png": 736,
	"./Background/4.png": 5425,
	"./Background/5.png": 6754,
	"./Base/0.png": 1465,
	"./Base/1.png": 7161,
	"./Base/2.png": 6117,
	"./Clothes/0.png": 3961,
	"./Clothes/1.png": 1481,
	"./Clothes/2.png": 6543,
	"./Clothes/3.png": 4376,
	"./Clothes/4.png": 2305,
	"./Face/0.png": 4514,
	"./Face/1.png": 5737,
	"./Face/2.png": 6118,
	"./Face/3.png": 1064,
	"./Face/4.png": 7462,
	"./Face/5.png": 3970,
	"./Hand/0.png": 7041,
	"./Hand/1.png": 5741,
	"./Hand/2.png": 8545,
	"./Hand/3.png": 7675,
	"./Hand/4.png": 4840,
	"./Hand/5.png": 5727,
	"./Hat/0.png": 668,
	"./Hat/1.png": 6968,
	"./Hat/2.png": 2036,
	"./Hat/3.png": 8974,
	"./Hat/4.png": 4221,
	"./Hat/5.png": 9022,
	"./Hat/6.png": 8284
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5162;